<script>
    export let mebot_img_url = '';
</script>

<center>
    <br><br><br>
<span style="display: flex; align-items:center; text-align: center; justify-content: center;">
<span class="info">You need a live Mebot to play this game! 💫<br><br> Get a live Mebot or Mebot egg 🥚 on your <b>Mebot Dashboard</b>.
    <!--<br><br>
    Or finish hatching your Mebot egg 🥚-->
    <br><br><br>
</span>
</span>
</center>

<style>
.info {
    text-shadow: 0 0 5px rgba(255, 254, 249, 0.4),
    0 0 8px rgba(251, 251, 251, 0.3);
    font-family: arial;
    color: hsl(60, 29%, 97%);
    font-size: 18px;
}
</style>